/**
 * Shimmer Placeholder Generator
 * 
 * Creates an animated SVG shimmer effect for image loading states.
 * Prevents Cumulative Layout Shift (CLS) while images load.
 */

const DEFAULT_WIDTH = 700;
const DEFAULT_HEIGHT = 475;

function createShimmerSvg(width: number, height: number): string {
  return `
    <svg width="${width}" height="${height}" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="g">
          <stop stop-color="#f6f7f9" offset="0%" />
          <stop stop-color="#e9ebee" offset="20%" />
          <stop stop-color="#f6f7f9" offset="40%" />
          <stop stop-color="#f6f7f9" offset="100%" />
        </linearGradient>
      </defs>
      <rect width="${width}" height="${height}" fill="#f6f7f9" />
      <rect id="r" width="${width}" height="${height}" fill="url(#g)" />
      <animate xlink:href="#r" attributeName="x" from="-${width}" to="${width}" dur="1s" repeatCount="indefinite" />
    </svg>`;
}

function toBase64(str: string): string {
  return typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str);
}

/**
 * Creates a base64-encoded data URL for a shimmer placeholder.
 */
export function createShimmerDataUrl(
  width: number = DEFAULT_WIDTH,
  height: number = DEFAULT_HEIGHT
): string {
  const svg = createShimmerSvg(width, height);
  return `data:image/svg+xml;base64,${toBase64(svg)}`;
}

/** Pre-computed shimmer for standard carousel dimensions */
export const CAROUSEL_SHIMMER = createShimmerDataUrl(DEFAULT_WIDTH, DEFAULT_HEIGHT);
